import { render } from "./cardHeading.component.vue?vue&type=template&id=23dfe243"
import script from "./cardHeading.component.vue?vue&type=script&lang=js"
export * from "./cardHeading.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/periple/cards/cardHeading.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23dfe243"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23dfe243', __exports__)) {
    console.log('reload')
    api.reload('23dfe243', __exports__)
  }
  
  module.hot.accept("./cardHeading.component.vue?vue&type=template&id=23dfe243", () => {
    console.log('re-render')
    api.rerender('23dfe243', render)
  })

}


export default __exports__